import { useQuery } from '@tanstack/react-query';

import { QUERY_KEYS } from '@/v2/constants/QueryKeys';
import useCurrentUser from '@/v2/domains/Auth/hooks/useCurrentUser.hook';
import getUnansweredSurveys, {
  GetUnansweredSurveysResponse,
} from '@/api/teacher/surveys/getUnansweredSurveys.endpoint';

import type { SurveyTag } from '../types/survey';
import { subQueryKey } from '../constants/constants';

type Params = {
  count?: number;
  queryKey?: string;
  tags: SurveyTag[];
  enabled?: boolean;
};

export default function useGetUnansweredSurveysQuery({
  count = 1,
  queryKey = subQueryKey,
  tags,
  enabled = true,
}: Params) {
  const { userId } = useCurrentUser();

  if (!tags) {
    throw new Error('useGetUnansweredSurveysQuery: `tags` is required');
  }

  return useQuery<GetUnansweredSurveysResponse>({
    queryKey: [QUERY_KEYS.SURVEYS, queryKey, { tags }],
    queryFn: () => getUnansweredSurveys({ count, tags }),
    enabled: !!userId && enabled,
    meta: {
      notification: {
        error: "We couldn't load surveys. Please try again.",
      },
    },
    staleTime: Infinity,
    gcTime: Infinity,
  });
}
